// extracted by mini-css-extract-plugin
export default {"indexpage":"indexpage_indexpage__OAD+L"};